import styled, { css } from 'styled-components';

import {
  zIndexElevatedLayer5,
  mediaTopBarVisible,
  mediaWideNavless,
  wideTypeMaxWidth,
} from '@xing-com/layout-tokens';
import { Logo } from '@xing-com/platform-layout-logo';
import {
  xdlColorBackground,
  scale010,
  scale170,
  xdlColorBorderSoft,
  scale210,
  spaceXXL,
  space3XL,
} from '@xing-com/tokens';

type StyledHeaderPlaceboProps = {
  $showOnSmallerScreens: boolean;
};

export const StyledHeaderPlacebo = styled.div<StyledHeaderPlaceboProps>`
  height: ${scale210};

  @media ${mediaTopBarVisible} {
    height: ${scale170};
  }

  @media ${mediaTopBarVisible} {
    ${({ $showOnSmallerScreens }) => {
      return $showOnSmallerScreens
        ? undefined
        : css`
            display: none;
          `;
    }}
  }

  @media print {
    display: none;
  }
`;

export const StyledHeaderWrapper = styled.header`
  background-color: ${xdlColorBackground};
  border-bottom: ${scale010} solid ${xdlColorBorderSoft};
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: calc(${zIndexElevatedLayer5} - 50);

  @media ${mediaTopBarVisible} {
    height: calc(${scale170});
  }
`;

export const StyledHeader = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  flex: 1 0 auto;
  flex-wrap: nowrap;

  height: ${scale210};
  @media ${mediaTopBarVisible} {
    height: ${scale170};
  }
`;

export const StyledLogoWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 100%;
`;

export const StyledLogoDesktop = styled(Logo)`
  margin-right: ${spaceXXL};
  display: flex;
  align-items: center;

  & svg {
    width: 82px;
  }

  @media ${mediaWideNavless} {
    & svg {
      width: 96px;
    }
  }

  @media (min-width: ${wideTypeMaxWidth}) {
    margin-right: ${space3XL};
  }
`;
